/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ChatRequest, ChatResponse, HTTPValidationError } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class LegalChat<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Proporciona orientación jurídica inicial basada en el ordenamiento jurídico colombiano, incluyendo referencias normativas y jurisprudenciales relevantes.
   *
   * @tags chat
   * @name ChatEndpointLegalChatConsultaPost
   * @summary Consulta Jurídica Virtual
   * @request POST:/legal-chat/consulta
   */
  chatEndpointLegalChatConsultaPost = (data: ChatRequest, params: RequestParams = {}) =>
    this.request<ChatResponse, HTTPValidationError>({
      path: `/api/v1/ask`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Obtiene las áreas de práctica disponibles para consulta
   *
   * @tags chat
   * @name GetPracticeAreasLegalChatAreasPracticaGet
   * @summary Áreas de Práctica
   * @request GET:/legal-chat/areas-practica
   */
  getPracticeAreasLegalChatAreasPracticaGet = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/legal-chat/areas-practica`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Serve the chat interface
   *
   * @tags chat
   * @name GetChatInterfaceLegalChatGet
   * @summary Get Chat Interface
   * @request GET:/legal-chat/
   */
  getChatInterfaceLegalChatGet = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/legal-chat/`,
      method: "GET",
      ...params,
    });
}
